import { accompanimentsSearchManager } from './accompanimentsSearch/accompanimentsSearch.manager'
import { accompanimentsBookedServicesManager } from './accompanimentsBookedServices/accompanimentsBookedServices.manager'
import { accompanimentsHistoryManager } from './accompanimentsHistory/accompanimentsHistory.manager'

export const accompanimentsManager = {
  ...accompanimentsSearchManager,
  ...accompanimentsBookedServicesManager,
  ...accompanimentsHistoryManager,
}



// WEBPACK FOOTER //
// ./src/domain/model/nursingHome/accompaniments/accompaniments.manager.ts